import { appInfo } from '../config/appinfo'

const fetchWithCredentials = async (url: string, options = {}) => {
  const response = await fetch(url, {
    credentials: 'include',
    ...options,
  })
  if (response.status === 404) return null 
  if (!response.ok) {
    throw new Error(`Failed to fetch: ${response.statusText}`)
  }
  return response.json()
}

export const exercisesAPI = {
  getModule: (moduleId: string) =>
    fetchWithCredentials(`${appInfo.apiDomain}/api/labs/labmodules/${moduleId}`),
  
  getModuleExercises: (moduleId: string) =>
    fetchWithCredentials(`${appInfo.apiDomain}/api/labs/labmodules/${moduleId}/exercises`),
  
  getExerciseFull: (exerciseId: string) =>
    fetchWithCredentials(`${appInfo.apiDomain}/api/labs/exercises/${exerciseId}/full`),

  getCurrentExercise: () =>
    fetchWithCredentials(`${appInfo.apiDomain}/api/labs/exercise/last`),

  resetExercise: (exerciseId: number | string) =>
    fetchWithCredentials(
      `${appInfo.apiDomain}/api/labs/exercises/${exerciseId}/reset`,
      { method: 'DELETE' }
    ),
}